import { Box, MenuItem, Select } from '@material-ui/core'
import { memo } from 'react'

import { formatDateToBR } from '../../../utils'
import { useStyles } from './styles'

interface SelectDiagnosisToAnalysisProps {
  value: string
  options: Array<{
    id: string
    name: string
    flight_date: string
  }>
  title: string
  onSelectChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

function SelectDiagnosisToAnalysisComponent({
  value,
  options = [],
  onSelectChange,
  title,
  placeholder = 'Selecione o diagnóstico para análise',
  disabled = false,
}: SelectDiagnosisToAnalysisProps) {
  const classes = useStyles()

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value as string
    onSelectChange(selectedValue)
  }

  const renderSelectedValue = (selectedValue: unknown) => {
    if (!selectedValue || selectedValue === '') {
      return placeholder
    }
    const selectedOption = options.find((option) => option.id === selectedValue)
    if (!selectedOption) {
      return placeholder
    }

    return (
      <Box className={classes.selectOption}>
        <span>{title}</span>
        <span className={classes.separatorOptionData}>&nbsp;</span>
        <span>Data do voo: {formatDateToBR(selectedOption.flight_date)}</span>
        <span className={classes.separatorOptionData}>&nbsp;</span>
        <span>{selectedOption.name}</span>
      </Box>
    )
  }

  return (
    <Box className={classes.selectContainer}>
      <Box className={classes.selectWrapper}>
        <Select
          className={classes.select}
          value={value}
          variant='outlined'
          onChange={handleSelectChange}
          displayEmpty
          disabled={disabled || options.length === 0}
          renderValue={renderSelectedValue}
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            getContentAnchorEl: null,
            elevation: 2,
            classes: { paper: classes.menuPaper },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}
              className={classes.menuItem}
            >
              <Box className={classes.selectOption}>
                <span>Data do voo: {formatDateToBR(option.flight_date)}</span>
                <span className={classes.separatorOptionData}>&nbsp;</span>
                <span>{option.name}</span>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  )
}

export const SelectDiagnosisToAnalysis = memo(
  SelectDiagnosisToAnalysisComponent,
)
